import React from 'react';
import { useSearchParams } from 'react-router-dom';
import SectionTabs, { SectionTab } from '../components/SectionTabs';
import { PageHeader } from '../components/ui';
import Roles from './Roles';
import Users from './Users';

const USER_TABS: SectionTab[] = [
  { id: 'users', label: 'Users' },
  { id: 'roles', label: 'Roles & Permissions' }
];

const UserAdminSection: React.FC = () => {
  const [searchParams, setSearchParams] = useSearchParams();

  const current = searchParams.get('tab');
  const activeTab = current === 'roles' ? 'roles' : 'users';

  const handleTabChange = (id: string) => {
    const next = new URLSearchParams(searchParams);
    next.set('tab', id);
    setSearchParams(next, { replace: true });
  };

  return (
    <div className="space-y-7">
      <PageHeader
        title="Users & Permissions"
        subtitle="Administer user accounts and fine-grained access control in one workspace."
      />

      <SectionTabs
        tabs={USER_TABS}
        activeTab={activeTab}
        onTabChange={handleTabChange}
      />

      <div>
        <div hidden={activeTab !== 'users'}>
          <Users tabVisible={activeTab === 'users'} />
        </div>
        <div hidden={activeTab !== 'roles'}>
          <Roles tabVisible={activeTab === 'roles'} />
        </div>
      </div>
    </div>
  );
};

export default UserAdminSection;


